export const DEFAULT_CHOICE = {
    "interaction_type":"choice",
    "question_text":"The quick bro.",
    "choice_answers":[
        {"answer_text":"answer text","is_correct_answer":true},
        {"answer_text":"answer text 2","is_correct_answer":false}
    ],
    "name":"The quick brown fox interaction",
    "difficulty_level":1,
    "category":2,
    "intro_text":"In about 10 seconds, some tests are going to be displayed, look at them carefully and answer as best as you can. ",
    "completion_text":"Congratulations on Completing!",
    "overall_completion_text":null,
    "pq_range_min":10,
    "pq_range_max":30,
    "min_per_interaction":-850,
    "max_per_interaction":850,
    "time_limit":120,
    "extra_time_required":1,
    "penalty":"2.00",
    "is_template":false
}

export const DEFAULT_DRAG_AND_DROP = {
    "interaction_type":"draganddrop",
    "options":[
        {"question":"What is the answer to this question?",
        "answer":"This is the answer",
        "completion_text":"This is not the answer"},
        {"question":"What is the answer to this question?",
        "answer":"This is the answer",
        "completion_text":"This is not the answer"}
    ],
    "name":"The quick brown fox interaction",
    "difficulty_level":1,
    "category":2,
    "intro_text":"This is the introduction to the interaction",
    "completion_text":"This is the text shown upon completion",
    "overall_completion_text":null,
    "pq_range_min":10,
    "pq_range_max":30,
    "min_per_interaction":-850,
    "max_per_interaction":850,
    "time_limit":120,
    "extra_time_required":1,
    "penalty":"2.00",
    "is_template":false
}

export const DEAFAULT_RECALL = {
    "interaction_type":"recall",
    "paragraph_copy":"The quick brown fox jumps over the lazy dog. The big bald eagle takes flight on one sunny Monday morning. Add more sentences to it to make it interesting.",
    "recall_words":[
        {"word":"fox","index":16},
        {"word":"dog","index":40},
        {"word":"eagle","index":58}
    ],
    "name":"The quick brown fox interaction",
    "difficulty_level":1,
    "category":2,
    "intro_text":"In about 10 seconds, some tests are going to be displayed, look at them carefully and answer as best as you can.","completion_text":"Congratulations on Completing!",
    "overall_completion_text":null,
    "pq_range_min":10,
    "pq_range_max":30,
    "min_per_interaction":-850,
    "max_per_interaction":850,
    "time_limit":12,
    "extra_time_required":1,
    "penalty":"2.00"
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Interactions/CreateInteraction/DefaultInteractions.ts